module.exports = __webpack_public_path__ + "img/user_elin_new.e0bb7625.png";